import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const Container = styled(CommonButton)(({ theme }) => ({
  paddingInlineEnd: '15rem',

  fontSize: theme.typography.size16,

  color: theme.page.nextStepBtn.textHover,
  backgroundColor: theme.page.nextStepBtn.bgHover,
  borderColor: 'transparent',

  '&:not([disabled]):hover': {
    color: theme.page.nextStepBtn.text,
    backgroundColor: theme.page.nextStepBtn.bg,
    borderColor: theme.page.nextStepBtn.text,
  },

  '&[disabled]': {
    color: theme.page.nextStepBtn.text,
    backgroundColor: theme.page.nextStepBtn.bg,
    borderColor: theme.palette.lighterGray,
    opacity: 1,
  },
}));
